var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2463",
    "data-name": "Group 2463",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.729,
    height: 30.729,
    viewBox: "0 0 30.729 30.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2457",
    "data-name": "Group 2457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9947",
    "data-name": "Path 9947",
    d: "M21.126,0H9.6A9.6,9.6,0,0,0,0,9.6V21.126a9.6,9.6,0,0,0,9.6,9.6H21.126a9.6,9.6,0,0,0,9.6-9.6V9.6A9.6,9.6,0,0,0,21.126,0Zm6.722,21.126a6.729,6.729,0,0,1-6.722,6.722H9.6a6.729,6.729,0,0,1-6.722-6.722V9.6A6.729,6.729,0,0,1,9.6,2.881H21.126A6.729,6.729,0,0,1,27.848,9.6Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460",
    transform: "translate(7.682 7.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9948",
    "data-name": "Path 9948",
    d: "M135.682,128a7.682,7.682,0,1,0,7.682,7.682A7.683,7.683,0,0,0,135.682,128Zm0,12.484a4.8,4.8,0,1,1,4.8-4.8A4.808,4.808,0,0,1,135.682,140.484Z",
    transform: "translate(-128 -128)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    transform: "translate(22.599 6.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.024,
    cy: 1.024,
    r: 1.024
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.aa6ef3312ff91c52b24d0b11565d5cfc.svg";
export { ForwardRef as ReactComponent };